/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './CustomizeAccountsView.scss';

import React from 'react';
import { connect } from 'react-redux';

import AccountVisibility from './AccountVisibility';
import PreferencesBreadCrumbs from 'components/layouts/Preferences/PreferencesBreadCrumbs';
import CustomAccountGroups from './CustomAccountGroups';
import DefaultViewSettings from './DefaultViewSettings';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import MobileCustomizeAccounts from './MobileCustomizeAccounts';

const CustomizeAccountsView = ({
  isDesktopLayout,
  has529Only,
  router,
  backPath = '/profile'
}) => {
  const isBackPath = router.location.pathname === backPath;
  if (isDesktopLayout) {
    return (
      <CustomizeAccounts
        has529Only={has529Only}
        isBackPath={isBackPath}
        backPath={backPath}
      />
    );
  }
  return (
    <MobileCustomizeAccounts
      has529Only={has529Only}
      isBackPath={isBackPath}
      backPath={backPath}
    />
  );
};

const CustomizeAccounts = ({ has529Only, isBackPath, backPath }) => {
  return (
    <div className="customize-accounts-container">
      <PreferencesBreadCrumbs isBackPath={isBackPath} backPath={backPath} />
      <PreferencesHeader>
        <div className="customize-accounts-view-header">
          Customize Account View
        </div>
      </PreferencesHeader>
      <div className="customize-accounts-main-wrapper">
        <div className="left-side-container">
          <DefaultViewSettings />
          {!has529Only && <CustomAccountGroups />}
        </div>
        <div className="right-side-container">
          <AccountVisibility />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isDesktopLayout: state.view.isDesktopLayout,
  has529Only: state.view.hasCollegeSavingsOnly,
  router: state.router
});

export default connect(mapStateToProps)(CustomizeAccountsView);
